<script>
  import { createEventDispatcher } from 'svelte';
  import { Checkbox, InlineNotification, Modal } from 'carbon-components-svelte';

  import LoadingSpinner from '../../../components/LoadingSpinner.svelte';

  import { getServerErrorMessage } from '../../../utils';
  import { countRestoreRequest } from '../../../services';

  const dispatch = createEventDispatcher();

  export let open = false,
    restoreRequest,
    blocked = true;

  let resultNotification,
    loading = false,
    understand = false;

  async function onFormSubmit() {
    if (!understand || blocked) {
      return;
    }

    resultNotification = null;
    loading = true;

    try {
      const approval = await countRestoreRequest(restoreRequest.id);
      loading = false;
      dispatch('close', approval);
    } catch (error) {
      const errorMessage = getServerErrorMessage(error) ?? 'Verify your submission and try again!';
      console.error('[ApprovalModal] Failed to request count!', errorMessage);
      resultNotification = {
        kind: 'error',
        title: 'Error:',
        subtitle: `Failed to request count! ${errorMessage}`,
      };
    } finally {
      loading = false;
    }
  }

  function handleClose() {
    if (loading) {
      return;
    }

    dispatch('close');
  }

  function stopPropagation(event) {
    event.stopPropagation();
  }

  function onCheck({ detail: checked }) {
    understand = checked;
  }
</script>

<Modal
  bind:open
  modalHeading="Get Number of Files and File Sizes"
  primaryButtonText="Proceed"
  secondaryButtonText="Cancel"
  shouldSubmitOnEnter={false}
  primaryButtonDisabled={loading || !understand || blocked}
  on:click:button--secondary={handleClose}
  on:close={handleClose}
  on:submit={onFormSubmit}
>
  <LoadingSpinner {loading} small showOverlay>
    {#if resultNotification}
      <InlineNotification
        kind={resultNotification.kind}
        lowContrast
        title={resultNotification.title}
        subtitle={resultNotification.subtitle}
        hideCloseButton
      />
    {/if}
    <p class="main">Get total file count and file sizes under requested paths.</p>
    <p><strong>You will not be able to approve the request until the file/size count is finished.</strong></p>
    <div class="understand">
      <Checkbox labelText="I understand and I want to proceed" checked={understand} on:click={stopPropagation} on:check={onCheck} />
    </div>
  </LoadingSpinner>
</Modal>

<style>
  .main {
    margin-bottom: 1rem;
  }

  .understand {
    margin-top: 1rem;
  }
</style>
